import React from 'react';
import { cn } from '@/lib/utils';

interface CandidatePageHeaderProps extends React.HTMLAttributes<HTMLDivElement> {}

const CandidatesPageHeader = ({ children, className, ...props }: React.PropsWithChildren<CandidatePageHeaderProps>) => {
    return (
        <div
            className={cn('border-border flex flex-row items-center border-b bg-white px-12 py-6', className)}
            {...props}
        >
            {children}
        </div>
    );
};

export default CandidatesPageHeader;
